
import { toast } from "react-toastify"
import { fetchConToken, fetchConTokenFileExcel } from "../helpers/fetch"

export const buyBudget = {

    getAll: async (filters) => {
        try {

            const params = (new URLSearchParams(filters)).toString()
            const resp = await fetchConToken(`buyBudgets/?${params}`)
            const body = await resp.json()

            if (body.ok) {
                return body.data || null

            } else {
                toast.error('Lo sentimos, ocurrió un error')
                return null
            }

        } catch (error) {
            console.log('---error--', error)
            toast.error(error)
        }
    },

    getOne: async (id) => {
        try {

            const resp = await fetchConToken(`buyBudgets/${id}`)
            const body = await resp.json()

            if (body.ok) {
                return body.data || null

            } else {
                toast.error('Lo sentimos, ocurrió un error')
                return null
            }

        } catch (error) {
            console.log('---error--', error)
            toast.error(error)
        }
    },

    save: async (data) => {
        try {

            const resp = await fetchConToken('buyBudgets', data, "POST")
            const body = await resp.json()

            if (body.ok) {

                toast.success(body.msg)
                return body.data.id

            } else {

                toast.error(body.msg)
                return null

            }

        } catch (error) {
            console.log('---error--', error)
            toast.error(error)
        }
    },

    update: async (data) => {
        try {

            const resp = await fetchConToken(`buyBudgets/${data.id}`, data, "PUT")
            const body = await resp.json()

            if (body.ok) {

                toast.success(body.msg)
                return body.data

            } else {

                toast.error(body.msg)
                return null
            }

        } catch (error) {
            console.log(error)
            toast.error(error)
        }
    },

    getExport: async (filters) => {
        try {

            const params = (new URLSearchParams(filters)).toString()
            const fileName = `pptos_gastos_${new Date()}_`
            const resp = await fetchConTokenFileExcel(`buyBudgets/export/excel/?${params}`, {}, 'GET', fileName)
            const body = await resp.json()

            if (body.ok) {
                return body.data || null

            } else {

                toast.error('Lo sentimos, ocurrió un error')
                return null

            }

        } catch (error) {
            console.log(error)
            toast.error(error)
        }
    }


}